import { fetcher } from "helpers/fetcher";

import {
  TUpdateStaffRetirementPaymentReq,
  TUpdateStaffRetirementPaymentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateStaffRetirementPayment = async (
  payload: TUpdateStaffRetirementPaymentReq
) => {
  return await fetcher<
    TUpdateStaffRetirementPaymentRes,
    TUpdateStaffRetirementPaymentReq["data"]
  >(ENDPOINT.USER.UPDATE_STAFF_RETIREMENT_PAYMENT, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.UPDATE_STAFF_RETIREMENT_PAYMENT.version,
    },
  });
};

export const mutationUpdateStaffRetirementPayment = async (
  payload: TUpdateStaffRetirementPaymentReq
) => {
  return (await updateStaffRetirementPayment(payload)).data.message;
};

mutationUpdateStaffRetirementPayment._key = (
  payload: TUpdateStaffRetirementPaymentReq
) => [ENDPOINT.USER.UPDATE_STAFF_RETIREMENT_PAYMENT.url, payload];
